import React, { useEffect, useState } from "react";
import AddLocationModal from "../../../components/Settings/Banner/modal/AddLocationModal";
import useBanner from "../../../hooks/useBanner";
import BannerLocationTable from "../../../components/Settings/Banner/BannerLocationTable";
import Loading from "../../../components/animation/loading";

function BannerLocations() {
  const [openAddlocation, setOpenAddlocation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [triggerFetchBannerLocation, setTriggerFetchBannerLocation] =
    useState(0);

  const [locationDatas, setLocationDatas] = useState([]);
  const [productFilter, setProductFilter] = useState("all");

  const { getLocations } = useBanner();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getLocations(setLoading);
        if (response) setLocationDatas(response);
      } catch (error) {
        setLoading(false);
      }
      setLoading(false);
    };

    fetchData();
  }, [triggerFetchBannerLocation]);

  const filteredLocationDatas =
    productFilter === "all"
      ? locationDatas
      : locationDatas.filter((item) => item.product === productFilter);

  return (
    <>
      <div className="flex flex-col">
        <div className="flex justify-between">
          <div className="flex flex-col">
            <span className="text-xl md:text-2xl font-semibold">
              Manage banner locations
            </span>
            <p>Before add location check location availability</p>
          </div>

          <div>
            <button
              onClick={() => setOpenAddlocation(true)}
              className="bg-theme1 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Add Location
            </button>
          </div>
        </div>

        <div className="mt-4">
          <select
            value={productFilter}
            onChange={(e) => setProductFilter(e.target.value)}
            className="border px-4 py-2 rounded-lg"
          >
            <option value="all">All</option>
            <option value="flight">Flight</option>
            <option value="hotel">Hotel</option>
            <option value="tour">Tour</option>
          </select>
        </div>

        {loading ? (
          <div className="flex justify-center">
            <Loading />
          </div>
        ) : filteredLocationDatas.length > 0 ? (
          <BannerLocationTable
            onTrigger={() => setTriggerFetchBannerLocation((t) => t + 1)}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            locationDatas={filteredLocationDatas}
          />
        ) : (
          <div className="flex justify-center items-center">
            <span className="text-xl md:text-2xl font-semibold">
              No locations found
            </span>
          </div>
        )}
      </div>

      {openAddlocation && (
        <AddLocationModal
          setOpenAddLocation={setOpenAddlocation}
          onTrigger={() => setTriggerFetchBannerLocation((t) => t + 1)}
          location={null}
        />
      )}
    </>
  );
}

export default BannerLocations;